export const getPathType = (path: string[], isTenantDomain: boolean): 'auth' | 'app' | 'tenant-domain' | 'public' => {
  if (isTenantDomain) return 'tenant-domain';
  if (!path) return 'public';
  if (path[0] === 'auth') return 'auth';
  if (path[0] === 'a') return 'app';
  return 'public';
};
